// router.js
import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '@/views/homePage.vue';
import jumpPage from '@/views/jumpPage.vue';
import pengYouQuanPage from '@/views/pengYouQuanPage.vue';

const routes = [
  {
    path: '/',
    name: 'homePage',
    component: HomePage
  },
  {
    path: '/pengYouQuanPage',
    name: 'pengYouQuanPage',
    component: pengYouQuanPage
  },
  {
    path: '/p/:id',
    name: 'jumpPage',
    component: jumpPage,
    props: true // 允许将路由参数作为 props 传递给组件
  },
  {
    path: '/:id',
    name: 'homePageWithId',
    component: HomePage,
    props: true
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;